import React from "react";
import { Box, Text } from "theme-ui";
import { motion } from "framer-motion";

import * as styles from "./PersonalizationCallOut.styles";

export default function PersonalizationCallOutV2({
  UIVersion,
  backgroundColor,
  position,
  zIndex,
  backgroundImageUrl,
  valueToDisplay,
  playerName,
  title,
  footer,
}) {
  const valueToDisplayLength = valueToDisplay?.length || playerName?.length;

  return (
    <Box sx={styles.personalizationCallOut({ UIVersion })}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <Box
          sx={styles.callout({
            backgroundColor,
            position,
            zIndex,
            UIVersion,
          })}
        >
          {title && <Box sx={styles.titleTextContainer}>{title}</Box>}
          <Box
            sx={styles.calloutImage({
              backgroundImageUrl,
            })}
          >
            <Text
              as="div"
              className="text"
              sx={styles.textV2({ backgroundImageUrl, valueToDisplayLength })}
            >
              {valueToDisplay || playerName}
            </Text>
          </Box>
          {footer && <Box sx={styles.bottomTextContainer}>{footer}</Box>}
        </Box>
      </motion.div>
    </Box>
  );
}
